<template>
  <div class="PermissionScreen">
    <img v-if="secondUserData" class="PermissionScreen__background" :src="backgroundUrl()" />
    <div class="PermissionScreen__main-container">
      <div v-if="activeSpinner" class="Spinner">
        <div class="Spinner__container">
          <div v-for="petal in 12" :key="petal" class="Spinner__petal"></div>
        </div>
      </div>
      <div v-if="!activeSpinner" class="PermissionScreen__content">
        <div class="PermissionScreen__icons-container">
          <svg width="51" height="51" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M51 12.333L40.333 23v-9.333c0-1.467-1.2-2.667-2.666-2.667h-16.48L51 40.813v-28.48zM3.72.333L.333 3.72 7.613 11H5.667A2.675 2.675 0 0 0 3 13.667v26.666C3 41.8 4.2 43 5.667 43h32c.56 0 1.04-.213 1.44-.48L47.613 51 51 47.613 3.72.333z"
              fill="#E54C4C"
              fill-rule="evenodd"
            />
          </svg>
          <svg width="48" height="51" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M42.667 24.333h-4.534c0 1.974-.426 3.814-1.146 5.467l3.28 3.28c1.493-2.613 2.4-5.573 2.4-8.747zm-10.72.454c0-.16.053-.294.053-.454v-16c0-4.426-3.573-8-8-8a7.99 7.99 0 0 0-8 8v.48l15.947 15.974zM3.387 3L0 6.387l16.027 16.026v1.92c0 4.427 3.546 8 7.973 8 .587 0 1.173-.08 1.733-.213l4.427 4.427c-1.893.88-4 1.386-6.16 1.386-7.36 0-14.133-5.6-14.133-13.6H5.333c0 9.094 7.254 16.614 16 17.92V51h5.334v-8.747c2.426-.346 4.72-1.2 6.773-2.4L44.613 51 48 47.613 3.387 3z"
              fill="#E54C4C"
              fill-rule="evenodd"
            />
          </svg>
        </div>
        <div
          class="PermissionScreen__title"
        >Something went wrong while trying to access your camera and microphone.</div>
        <div
          class="PermissionScreen__description"
        >It seems that your web browser does not have permission to use camera and microphone.</div>
        <div class="PermissionScreen__description">
          Click on
          <svg width="16" height="13" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
              <path
                d="M1 0h9.0034c.5523 0 1 .4477 1 1v2L15 1v4H9.0484c-.5522 0-1 .4477-1 1v3c0 .5523-.4477 1-1 1H1c-.5523 0-1-.4477-1-1V1c0-.5523.4477-1 1-1z"
                fill="#BDC0C6"
              />
              <rect fill="#D90403" x="9" y="6" width="7" height="7" rx="1" />
              <path
                d="M13.2071 9.5l1.4142 1.4142-.707.7071L12.5 10.2071l-1.4142 1.4142-.7071-.707L11.7929 9.5l-1.4142-1.4142.707-.7071L12.5 8.7929l1.4142-1.4142.7071.707L13.2071 9.5z"
                fill="#FFF"
              />
            </g>
          </svg>
          at the top-right corner of browser window and select „Always allow https://calls.kingsch.at to access your microphone and camera.”
        </div>
        <div class="PermissionScreen__description">or</div>
        <div
          class="PermissionScreen__description"
        >It seems that your camera or microphone is unplugged.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PermissionScreen',

  data() {
    return {
      activeSpinner: true,
    }
  },

  computed: {
    ...mapState({
      secondUserData: state => state.call.secondUserData,
    }),
  },

  mounted() {
    setTimeout(() => (this.activeSpinner = false), 2000)
  },

  methods: {
    removeSpinner() {
      this.activeSpinner = false
    },
    backgroundUrl() {
      if (
        this.secondUserData &&
        this.secondUserData.user &&
        this.secondUserData.user.avatarUrl
      ) {
        return this.secondUserData.user.avatarUrl
      }

      return require('../static/images/default-user-avatar.jpg')
    },
  },
}
</script>

<style scoped lang="scss">
@import 'PermissionScreen';
</style>